import React from 'react'

import config from '../../config'
import { KEY_MAP } from '../ApiProvider/helpers'
import { useTaskAPI } from '../TaskAPIProvider'
import useUIPagination from '../../hooks/useUIPagination'
import useTaskColumnSettings from '../../hooks/useTaskColumnSettings'

const AllTaskTableStateContext = React.createContext(null)

export const PAGE_SIZE = 25
export const NAME = 'All Tasks'

const getUrl = url => (page, per_page) => {
  const transformed = KEY_MAP.allTasks(['allTasks', url])
  const fullUrl = `${config.apiBaseUri}${transformed}&page=${page}&per_page=${per_page}`
  return fullUrl
}

const AllTaskTableStateProvider = ({ tasks, url, children }) => {
  const { formatTask } = useTaskAPI()

  const formattedTasks = React.useMemo(() => {
    if (!tasks) {
      return []
    }

    return tasks.data.map(formatTask)
  }, [tasks, formatTask])

  const {
    visibleElems: visibleTasks,
    updatePagination,
    ...pagination
  } = useUIPagination(formattedTasks, PAGE_SIZE, NAME, true)
  const columnSettings = useTaskColumnSettings(NAME)

  React.useEffect(() => {
    if (tasks && url) {
      updatePagination(tasks.pagination, getUrl(url))
    }
  }, [updatePagination, tasks, url])

  return (
    <AllTaskTableStateContext.Provider
      value={{
        // Base table values
        tasks: visibleTasks,
        expanded: true,
        name: NAME,
        id: null,
        canAdd: false,
        key: NAME,

        // Pagination props
        ...pagination,

        // Column Setting props
        ...columnSettings
      }}
    >
      {children}
    </AllTaskTableStateContext.Provider>
  )
}

export default AllTaskTableStateProvider

export const useAllTaskTableState = () =>
  React.useContext(AllTaskTableStateContext)
